module.exports = __webpack_public_path__ + "img/aliyun.9c1c7f11.svg";